import React from "react";
import { Page, withForm } from "components/common";
import { FormGroup, SaveButton } from "components/common/Forms";
import { compose, withState } from "recompose";
import { Alert } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

const messages = {
  EmailFailed: "Unable to send a password reset email at this time",
};

export const PasswordResetRequest = ({
  item,
  form,
  setDispatch,
  onSubmit,
  onUpdate,
  onChange,
  success,
  failure,
}) => (
  <Page title="Forgotten Password">
    {success ? (
      <Alert color="success">
        <span className="fa fa-check mr-1" />
        An email has been sent to you containing instructions on how to reset
        your password
      </Alert>
    ) : (
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
      >
        <p>
          If you've forgotten your password, enter your email and we will email
          you instructions on how to reset it.
        </p>
        <FormGroup label="Email *" model=".email">
          <Control.text type="email" model=".email" required />
        </FormGroup>
        {!!failure && <Alert color="danger">{failure}</Alert>}
        <div className="tw-flex tw-justify-between">
          <Link to="/login">
            <Trans>Back to login</Trans>
          </Link>
          <SaveButton className="float-right" form={form}>
            Send reset
          </SaveButton>
        </div>
      </LocalForm>
    )}
  </Page>
);

const enhance = compose(
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withForm({
    onSubmit:
      ({ client, item: { email }, setSuccess, setFailure }) =>
      () => {
        setSuccess(false);
        setFailure(null);

        return client
          .post("/password_reset_request", {
            email,
          })
          .tap(() => {
            setSuccess(true);
          })
          .catch((err) => {
            const code = get(err, "response.data.code");
            const message = messages[code];
            if (message) {
              setFailure(message);
            } else {
              throw err;
            }
          });
      },
  })
);

export default enhance(PasswordResetRequest);
